const STORAGE_KEY = 'userPreferences';

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function persist(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      tripsAutoRefreshInterval: state.tripsAutoRefreshInterval,
    }));
  } catch {
    // localStorage unavailable — silently skip
  }
}

const saved = load();

const defaultState = {
  tripsAutoRefreshInterval: saved.tripsAutoRefreshInterval ?? null,
};

const getters = {
  tripsAutoRefreshInterval: (state) => state.tripsAutoRefreshInterval,
};

const mutations = {
  SET_TRIPS_AUTO_REFRESH_INTERVAL(state, interval) {
    state.tripsAutoRefreshInterval = interval;
    persist(state);
  },
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
};